import type {
  FrapiListItem,
  ListProperties,
} from '../../../../types/frapi-types.js';
import type { TeaserListProps } from '../../../components/teasers/TeaserList.js';

import { console } from '../../../../../core/system/console/console.server.js';

type RelatedTopList = {
  id: string;
  imageId: string;
  section: string;
  title: string;
};

const isRelatedToplist = (value: unknown): value is RelatedTopList =>
  typeof value === 'object' &&
  value !== null &&
  'id' in value &&
  typeof value.id === 'string' &&
  'imageId' in value &&
  typeof value.imageId === 'string' &&
  'section' in value &&
  typeof value.section === 'string' &&
  'title' in value &&
  typeof value.title === 'string';

const toFrapiListItem = (relatedList: RelatedTopList): FrapiListItem => ({
  locale: 'no',
  id: relatedList.id,
  type: 'list',
  properties: {
    title: relatedList.title,
    image: relatedList.imageId,
    section: relatedList.section,
  },
});

const toRelatedTopListTeaser = (
  listItem: FrapiListItem,
  isMobile: boolean,
  width: number,
  height: number,
): TeaserListProps => ({
  ...listItem,
  mobile: isMobile,
  size: 'small',
  slug: '',
  extraPath: '/mat-og-drikke/',
  width,
  height,
});

const parseRelatedTopLists = (str: string): RelatedTopList[] => {
  try {
    const raw = JSON.parse(str);

    if (!Array.isArray(raw)) {
      return [];
    }

    return raw.filter(isRelatedToplist);
  } catch (err) {
    console.error('Failed to parse linksTo property:', err);

    return [];
  }
};

const getRelatedTopLists = (
  listProperties: ListProperties,
): FrapiListItem[] => {
  if (typeof listProperties.linksTo !== 'string' || !listProperties.linksTo) {
    return [];
  }

  const lists = parseRelatedTopLists(listProperties.linksTo);

  if (!lists.length) {
    return [];
  }

  return lists.map(toFrapiListItem);
};

export { getRelatedTopLists, toRelatedTopListTeaser };
